import { configureStore } from '@reduxjs/toolkit';
import dronesReducer from './slices/dronesSlice';
import connectionReducer from './slices/connectionSlice';
import themeReducer from './slices/themeSlice';
import homeBaseReducer from './slices/homeBaseSlice';
import missionPlannerReducer from './slices/missionPlannerSlice';
import geofenceReducer from './slices/geofenceSlice';
import safetyReducer from './slices/safetySlice';
import userReducer from './slices/userSlice';
import mapViewReducer from './slices/mapViewSlice';
import flightTrackReducer from './slices/flightTrackSlice';

/**
 * The application's reducers.
 *
 * Exported so tests can build a store from the same map the app uses. Test
 * stores that list reducers by hand drift silently every time a slice is added
 * — a component starts reading state.<new> and every such test throws, with
 * nothing having changed in the component's own test.
 */
export const appReducers = {
  drones: dronesReducer,
  connection: connectionReducer,
  theme: themeReducer,
  homeBase: homeBaseReducer,
  missionPlanner: missionPlannerReducer,
  geofence: geofenceReducer,
  safety: safetyReducer,
  user: userReducer,
  mapView: mapViewReducer,
  flightTrack: flightTrackReducer,
};

export const store = configureStore({
  reducer: appReducers,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
